var getOffsetTop = function getOffsetTop(el) {
  return el && el.offsetTop || 0;
};

var getOffsetHeight = function getOffsetHeight(el) {
  return el && el.offsetHeight || 0;
};

var getWindowHeight = function getWindowHeight(el) {
  return el ? window.innerHeight : 0;
};

export default {
  data: function data() {
    return {
      $scroll_x: 0,
      $scroll_y: 0
    };
  },
  created: function created() {
    window.addEventListener('scroll', this.$_scroll_onScroll, {
      passive: true
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.$_scroll_onScroll, {
        passive: true
      });
    }
  },
  methods: {
    $_scroll_onScroll: function $_scroll_onScroll() {
      this.$data.$scroll_x = window.scrollX;
      this.$data.$scroll_y = window.scrollY;
    },
    $scroll_hasLeftAtTop: function $scroll_hasLeftAtTop(el) {
      var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var elHeight = getOffsetHeight(el) * threshold;
      return this.$data.$scroll_y > getOffsetTop(el) + elHeight;
    },
    $scroll_hasEnteredFromBottom: function $scroll_hasEnteredFromBottom(el) {
      var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var whiteSpaceHeight = getWindowHeight(el) - getOffsetHeight(el) * threshold;
      return this.$data.$scroll_y > getOffsetTop(el) - whiteSpaceHeight;
    }
  }
};